import { render, staticRenderFns } from "./OpenDetail.vue?vue&type=template&id=129235c8&scoped=true"
import script from "./OpenDetail.vue?vue&type=script&lang=js"
export * from "./OpenDetail.vue?vue&type=script&lang=js"
import style0 from "./OpenDetail.vue?vue&type=style&index=0&id=129235c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129235c8",
  null
  
)

export default component.exports